import { SerializedError } from '@reduxjs/toolkit';
import Axios, { AxiosError } from 'axios';
import _ from 'lodash';

import i18n from 'src/i18n';
import store from 'src/store';
import { startSignOut } from 'src/store/auth/auth';
import { startProgress, stopProgress } from 'src/store/progress';

export enum ApiErrorCode {
  UNKNOWN_ERROR = 'http.UNKNOWN_ERROR',
  INTERNAL_SERVER_ERROR = 'http.INTERNAL_SERVER_ERROR',
  UNAUTHORIZED = 'http.UNAUTHORIZED',
}
const errorCodeByStatus: {
  [key: number]: ApiErrorCode;
} = {
  500: ApiErrorCode.INTERNAL_SERVER_ERROR,
};

// interface ApiErrorDto {
//   errorCode: string;
//   errorMessage?: string;
// }
// export interface ApiError extends ApiErrorDto {
//   status: number;
//   error?: AxiosError;
// }
// // eslint-disable-next-line @typescript-eslint/no-explicit-any
// export function isApiError(error: any): error is ApiError {
//   const apiError = error as ApiError;
//   return apiError.errorCode !== undefined && apiError.status !== undefined;
// }
export class ApiErrorHelper {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  static isErrorCode(error: any, errorCode: string): boolean {
    return error && 'name' in error && error.name === errorCode;
  }
}

const axios = Axios.create({
  withCredentials: true,
});

// Add a request interceptor
axios.interceptors.request.use((config) => {
  store.dispatch(startProgress());

  // TODO X-HTTP-Method-Override 옵션. 서버 준비 되기 전가지 주석처리함
  // const method = config.method?.toUpperCase();
  // if (method === 'PUT' || method === 'DELETE' || method === 'PATCH') {
  //   config.headers = { ...config.headers, 'X-HTTP-Method-Override': method };
  //   config.method = 'POST';
  // }

  const authEntity = store.getState().auth.authEntity;
  if (authEntity) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${authEntity.tokenStr}`,
    };
  }

  if (i18n.language) {
    config.headers = {
      ...config.headers,
      'Accept-Language': `${i18n.language},en-US;q=0.9,en;q=0.8`,
    };
  }

  return config;
});

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    store.dispatch(stopProgress());
    return response;
  },
  (error: AxiosError) => {
    // const { t } = useTranslation(['error']);
    store.dispatch(stopProgress());

    let se: SerializedError;
    if (!error.response) {
      se = {
        name: ApiErrorCode.UNKNOWN_ERROR,
        stack: error.stack,
      };
      return Promise.reject(se);
    }

    // TODO 특정 에러코드일 경우 강제 로그아웃. 일단은 401일 경우 무조건 로그아웃 하도록 처리.
    if (error.response.status === 401) {
      // store.dispatch(thunkSignOut());
      if (!store.getState().auth.progressSignOut) {
        // console.log('startSignOut');
        store.dispatch(startSignOut());
      }

      if (!_.has(error.response.data, 'errorCode') || error.response.data.errorCode === undefined) {
        se = {
          name: ApiErrorCode.UNAUTHORIZED,
        };
        return Promise.reject(se);
      }
    }

    if (_.has(error.response.data, 'errorCode') && error.response.data.errorCode) {
      se = {
        name: error.response.data.errorCode,
        message: error.response.data.errorMessage,
      };
    } else {
      se = {
        name: errorCodeByStatus[error.response.status] || ApiErrorCode.INTERNAL_SERVER_ERROR,
      };
    }
    return Promise.reject(se);
  }
);

export default axios;
